import styled from "@emotion/styled/macro";
import { forwardRef } from "react";

type IFrameNavButtonProps = {
  basePath: string;
  src: string;
  title: string;
};

const IFrameNavButton = forwardRef<HTMLIFrameElement, IFrameNavButtonProps>(
  (props, ref) => {
    const { basePath, src, title } = props;
    if (!title || !basePath || !src || !ref) {
      return null;
    }
    return (
      <IFrameNavButtonContainer
        key={basePath}
        ref={ref}
        src={src}
        title={title}
        data-testid={`sidenav-item-${title.toLowerCase().replace(" ", "-")}`}
      />
    );
  }
);

const IFrameNavButtonContainer = styled.iframe`
  height: 25px;
  width: 25px;
  border: 0px;
  overflow: hidden;
`;

export { IFrameNavButton };
